
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import validator from '../../api/validator';

import api from '../../api';
import UpLoad from '../../components/LoansUpload';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
});
},
components: {
Group,
XInput,
XButton,
UpLoad,
},
mounted() {
this.getOldData();
},
activated() {
},
data() {
return {
imgUrl: '',
defaultUrl: require('../../assets/images/logo_G7@2x.png'),
formData: {
username: '',
realname: '',
mobile: '',
telephone: '',
email: '',
position: '',
avatar: null,
},
rule: {
isMobile(val) {
return {
valid: validator.isMobile(val),
msg: '请输入正确的手机号码',
};
},
isTel(val) {
return {
valid: validator.isTel(val),
msg: '请输入正确的座机号码',
};
},
isMail(val) {
return {
valid: validator.isMail(val),
msg: '请输入正确的邮箱',
};
},
},
};
},
computed: {
},
methods: {
saveForm() {
if (!this.rule.isMobile(this.formData.mobile).valid || !this.rule.isTel(this.formData.telephone).valid ||!this.rule.isMail(this.formData.email).valid) {
this.$vux.toast.text('请填写正确的信息');
} else {
const _this = this;
api.vega.user.updateUserInfo(this.formData).then(() => {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
_this.$router.go(-1);
}
});
});
}
},
getImgUrl(res) {
this.formData.avatar = res.url;
},
getOldData() {
api.vega.user.getUserInfo({}).then((res) => {
const data = res.data.data;

this.formData = {
username: data.username || '',
realname: data.realname || '',
mobile: data.mobile || '',
telephone: data.telephone || '',
email: data.email || '',
position: data.position || '',
avatar: data.avatar,
};
});
},
},
};
